function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M40 12c-3.028 0-4 1.094-4 4.5 0 2.666 1.402 5.5 4 5.5s4-2.834 4-5.5c0-3.406-.972-4.5-4-4.5zm0 12c-3.421 0-6-3.225-6-7.5 0-3.026.682-6.5 6-6.5s6 3.474 6 6.5c0 4.275-2.579 7.5-6 7.5z",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M48 32H32c-1.626 0-3-1.832-3-4v-2.58l7.504-4.288.992 1.736L31 26.58V28c0 1.224.703 2 1 2h16c.297 0 1-.776 1-2v-1.42l-6.496-3.712.992-1.736L51 25.42V28c0 2.168-1.374 4-3 4M19 50c-3.028 0-4 1.094-4 4.5 0 2.666 1.402 5.5 4 5.5s4-2.834 4-5.5c0-3.406-.972-4.5-4-4.5zm0 12c-3.421 0-6-3.225-6-7.5 0-3.026.682-6.5 6-6.5s6 3.474 6 6.5c0 4.275-2.579 7.5-6 7.5z",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M27 70H11c-1.626 0-3-1.832-3-4v-2.58l7.504-4.288.992 1.736L10 64.58V66c0 1.224.703 2 1 2h16c.297 0 1-.776 1-2v-1.42l-6.496-3.712.992-1.736L30 63.42V66c0 2.168-1.374 4-3 4M61 50c-3.028 0-4 1.094-4 4.5 0 2.666 1.402 5.5 4 5.5s4-2.834 4-5.5c0-3.406-.972-4.5-4-4.5zm0 12c-3.421 0-6-3.225-6-7.5 0-3.026.682-6.5 6-6.5s6 3.474 6 6.5c0 4.275-2.579 7.5-6 7.5z",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M69 70H53c-1.626 0-3-1.832-3-4v-2.58l7.504-4.288.992 1.736L52 64.58V66c0 1.224.703 2 1 2h16c.297 0 1-.776 1-2v-1.42l-6.496-3.712.992-1.736L72 63.42V66c0 2.168-1.374 4-3 4",
  fill: "#EA7125"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M39 46h2V36h-2z"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M30.625 54.781l-1.25-1.562 10-8 1.25 1.562-10 8"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M49.375 54.781l-10-8 1.25-1.562 10 8-1.25 1.562"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationOrganisation = function SvgIconIllustrationOrganisation(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationOrganisation;